import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

export default function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: 'instant' });

    document.documentElement.scrollTop = 0;
    document.body.scrollTop = 0;

    const mainContent = document.getElementById('main-content') ||
                        document.querySelector('main') ||
                        document.querySelector('.page-wrapper') ||
                        document.querySelector('.content');
    if (mainContent) mainContent.scrollTop = 0;
  }, [pathname]);

  return null;
}
